import React from "react";
import { css } from "@emotion/react";
import consulting from "@src/assets/expert/consulting.png";
import writingFace from "@src/assets/expert/writingFace.png";

const TakerConsultNotice = () => {
    return (
        <div css={noticeContainerStyle}>
            <div css={TitleStyle}>
                매물컨설팅 <br />
                <span style={{ fontWeight: "normal", fontSize: "18px" }}>서비스 이렇게 진행돼요!</span>
            </div>
            <div css={ContentContainerStyle}>
                {/* Step1 */}
                <div className="stepBox">
                    <img src={consulting} alt="consulting" className="stepIcon" width={50} height={50} />
                    <p css={BlackTitleStyle}>
                        <span css={BlackStepStyle}>step.01</span> 매물컨설팅
                    </p>
                    <div css={BlueBoxStyle}>
                        <p css={BlackSubTitleStyle}>의뢰인에게 권리분석 등 매물에 대한 컨설팅을 제공해요. </p>
                        <p css={GreyContentStyle}>
                            ✔️ 컨설팅 비용 : 33만원 <br />
                            (📍 수수료 : 해당 금액의 10%로 공제 후 지급)
                            <br />
                            ✔️ 매칭 1회 실패시, 의뢰인은 컨설팅 비용을 <br />
                            최대 80만원까지 올려 다시 요청할 수 있어요.
                            <br />
                            <br />
                        </p>
                        <div css={dividerStyle} style={{ margin: "8px 0" }} />

                        <div css={FlexColumnStyle} style={{ marginTop: "24px" }}>
                            <div>
                                <p css={BlueTitleStyle}>❶ 의뢰 요청 받기</p>
                                <p css={GreyContentStyle} style={{ marginTop: "8px", marginLeft: "20px" }}>
                                    전국에 있는 경매대행 전문가에게 <br />
                                    경매 매물에 대한 컨설팅 의뢰가 들어와요. <br />
                                </p>
                            </div>
                            <div>
                                <p css={BlueTitleStyle}>❷ 신청하기</p>
                                <p css={GreyContentStyle} style={{ marginTop: "8px", marginLeft: "20px" }}>
                                    전문가들은 해당 의뢰에 실시간으로 지원하고, <br />
                                    의뢰인은 지원한 전문가들의 프로필을 확인하거나 <br />
                                    채팅을 하며 자신이 원하는 전문가를 직접 선택해요.
                                </p>
                            </div>
                            <div>
                                <p css={BlueTitleStyle}>❸ 매칭 완료</p>
                                <p css={GreyContentStyle} style={{ marginTop: "8px", marginLeft: "20px" }}>
                                    의뢰인이 지원한 전문가 중 한 명을 선택하고 ‘매칭확정하기’를 눌러 담당 전문가로 지정되면,
                                    매칭이 완료돼요.
                                </p>
                            </div>
                            <div>
                                <p css={BlueTitleStyle}>❹ 컨설팅 제공 </p>
                                <p css={GreyContentStyle} style={{ marginTop: "8px", marginLeft: "20px" }}>
                                    매칭이 확정된 전문가는 의뢰인이 요청한 권리 분석, 입지 분석 등 매물에 대한 컨설팅을 제공해요.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Step2 */}
                <div className="stepBox">
                    <img src={writingFace} alt="step2" className="stepIcon" width={50} height={50} />

                    <p css={BlackTitleStyle}>
                        <span css={BlackStepStyle}>step.02</span> 후기 확인
                    </p>
                    <p css={DarkGreyContentStyle} style={{ marginTop: "14px" }}>
                        담당한 의뢰인이 작성한 후기를 확인할 수 있어요! <br />
                        정산 금액은 의뢰인이 완료한 후 3일 이내 [내정보]에 입력한 전문가 계좌로 지급돼요. (의뢰인이 완료하지 않을
                        경우 14일 이내 자동 완료 처리돼요.)
                    </p>
                </div>
            </div>
        </div>
    );
};

export default TakerConsultNotice;

export const noticeContainerStyle = css`
    width: 100%;
    padding: 30px 14px;
`;

export const TitleStyle = css`
    color: #0c002c;
    font-size: 20px;
    font-weight: bold;
    line-height: 1.4;
    text-align: left;
    margin-bottom: 28px;
`;

export const ContentContainerStyle = css`
    padding-left: 30px;
    margin-left: 24px;
    border-left: 2px solid #efefef;

    .stepBox {
        position: relative;
    }

    .stepIcon {
        position: absolute;
        top: -12px;
        left: -56px;
    }
`;

export const BlueBoxStyle = css`
    width: 100%;
    padding: 14px;
    background-color: #eff8ff;
    border-radius: 8px;
    margin-top: 24px;
    margin-bottom: 24px;
`;

export const BlueTitleStyle = css`
    color: #2275ee;
    font-size: 15px;
    font-weight: bold;
    line-height: 1.2;
`;

export const BlackTitleStyle = css`
    color: #282828;
    font-size: 16px;
    font-weight: bold;
    line-height: 1.4;
`;

export const BlackSubTitleStyle = css`
    color: #382e51;
    font-size: 14px;
    font-weight: bold;
    line-height: 1.4;
    margin-bottom: 14px;
`;
export const BlackStepStyle = css`
    color: #282828;
    font-size: 11px;
    font-weight: bold;
    line-height: 1.4;
    margin-bottom: 8px;
`;

export const BlackContentStyle = css`
    color: #3c3c3c;
    font-size: 13px;
    line-height: 1.4;
`;

export const GreyContentStyle = css`
    color: #8d8d8d;
    font-size: 13px;
    line-height: 1.4;
`;

export const RedContentStyle = css`
    color: #ff0000;
    font-size: 12px;
    line-height: 1.4;
`;

export const RedTitleStyle = css`
    color: #ff0000;
    font-size: 15px;
    font-weight: bold;
    line-height: 1.4;
`;

export const dividerStyle = css`
    width: 100%;
    height: 1px;
    background-color: #e8e8e8;
    margin-top: 14px;
    margin-bottom: 14px;
`;

export const FlexColumnStyle = css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 20px;
`;
export const DarkGreyContentStyle = css`
    color: #505050;
    font-size: 14px;
    line-height: 1.4;
`;
